/* eslint-disable */
const appElements = $('.application-eligitiblity + .application-form'),
      appConfirm  = $('.app-confirm'),
      appSubmit   = $('#application-submit');

export default {
  init() {
    appElements.addClass('disabled');
    // appSubmit.css('width', appSubmit.outerWidth() + 'px');
  },
  finalize() {

    appConfirm.on('click touch', function(){
      appElements.removeClass('disabled');
    });

    $('#new_application').on('submit', function(e){
      // Add processing and block pointer events
      appSubmit.addClass('processing-submit').attr('value', 'Submitting...');
    })

//  $('#new_application').on('submit', function(e){
//       e.preventDefault();
//       appSubmit.addClass('processing').prop('value', 'Processing...');
//
//       var formPOST = $(this).serializeArray();
//
//       $.ajax({
//           type: 'post',
//           // dataType: 'json',
//           url: myAjax.ajaxurl,
//           data: {
//               action: formPOST[0].value,
//               data: formPOST,
//           },
//
//           success: function(data){
//             data = JSON.parse(data);
//             console.log(data);
//             // console.log(data.status);
//             // console.log(formPOST);
//             // if(data.status == 'complete') {
//             //   window.location.replace(data.return);
//             // }
//
//           },
//       });
//
//
//       //JS form validation
//
//       //if Invalid
//       // appSubmit.removeClass('processing').prop('value', 'Submit application');
//
//       //If Valid
//       // appSubmit.removeClass('processing').prop('value', 'Submitted!');
//     });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/applications.js